<template>
  <main>
    <div class="container mx-auto pt-16">
      <h1
        class="
          text-black
          font-extrabold
          xl:text-5xl
          text-3xl
          mb-4
          text-center
          md:text-center
          lg:text-center
        "
      >
        What Our Users Says
      </h1>
      <p
        class="
          text-xl text-center
          md:text-center
          xl:w-2/3
          lg:w-2/3
          w-11/12
          mx-auto
          text-black
          mb-12
        "
      >
        Trackee gives the ability to track the hours of my task and see where
        i'm profitable, right down to the task level
      </p>
    </div>
    <div class="w-full py-16 my-24">
      <div class="container relative mx-auto">
        <div class="absolute -mt-16 top-0">
          <svg width="151" height="104" xmlns="http://www.w3.org/2000/svg">
            <g fill="#0c0e2d" fill-rule="evenodd">
              <rect x=".88" width="3" height="3" rx="1.5" />
              <rect x="17.88" width="3" height="3" rx="1.5" />
              <rect x="32.88" width="3" height="3" rx="1.5" />
              <rect x="49.88" width="3" height="3" rx="1.5" />
              <rect x="65.88" width="3" height="3" rx="1.5" />
              <rect x="82.88" width="3" height="3" rx="1.5" />
              <rect x="98.88" width="3" height="3" rx="1.5" />
              <rect x="115.88" width="3" height="3" rx="1.5" />
              <rect x="131.88" width="3" height="3" rx="1.5" />
              <rect x="147.88" width="3" height="3" rx="1.5" />
              <rect x=".88" y="13" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="13" width="3" height="3" rx="1.5" />
              <rect x=".88" y="25" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="25" width="3" height="3" rx="1.5" />
              <rect x=".88" y="38" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="38" width="3" height="3" rx="1.5" />
              <rect x=".88" y="51" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="51" width="3" height="3" rx="1.5" />
              <rect x=".88" y="63" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="63" width="3" height="3" rx="1.5" />
              <rect x=".88" y="76" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="76" width="3" height="3" rx="1.5" />
              <rect x=".88" y="89" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="89" width="3" height="3" rx="1.5" />
              <rect x=".88" y="101" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="101" width="3" height="3" rx="1.5" />
            </g>
          </svg>
        </div>
        
        <div class="absolute -mb-16 bottom-0 right-0">
          <svg width="151" height="104" xmlns="http://www.w3.org/2000/svg">
            <g fill="#0c0e2d" fill-rule="evenodd">
              <rect x=".88" width="3" height="3" rx="1.5" />
              <rect x="17.88" width="3" height="3" rx="1.5" />
              <rect x="32.88" width="3" height="3" rx="1.5" />
              <rect x="49.88" width="3" height="3" rx="1.5" />
              <rect x="65.88" width="3" height="3" rx="1.5" />
              <rect x="82.88" width="3" height="3" rx="1.5" />
              <rect x="98.88" width="3" height="3" rx="1.5" />
              <rect x="115.88" width="3" height="3" rx="1.5" />
              <rect x="131.88" width="3" height="3" rx="1.5" />
              <rect x="147.88" width="3" height="3" rx="1.5" />
              <rect x=".88" y="13" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="13" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="13" width="3" height="3" rx="1.5" />
              <rect x=".88" y="25" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="25" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="25" width="3" height="3" rx="1.5" />
              <rect x=".88" y="38" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="38" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="38" width="3" height="3" rx="1.5" />
              <rect x=".88" y="51" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="51" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="51" width="3" height="3" rx="1.5" />
              <rect x=".88" y="63" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="63" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="63" width="3" height="3" rx="1.5" />
              <rect x=".88" y="76" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="76" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="76" width="3" height="3" rx="1.5" />
              <rect x=".88" y="89" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="89" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="89" width="3" height="3" rx="1.5" />
              <rect x=".88" y="101" width="3" height="3" rx="1.5" />
              <rect x="17.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="32.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="49.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="65.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="82.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="98.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="115.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="131.88" y="101" width="3" height="3" rx="1.5" />
              <rect x="147.88" y="101" width="3" height="3" rx="1.5" />
            </g>
          </svg>
        </div>
        <section id="carousel">
          <!--slides for slider-->
          <figure class="visible">
            <div class="w-11/12 mx-auto bg-white py-10 sm:px-16 px-10 relative">
              <div class="flex items-center justify-between pb-8">
                <div class="xl:flex md:flex lg:flex sm:flex items-center">
                  <div class="h-20 w-20">
                    <img
                      src="/user/shade.png"
                      alt=""
                      class="rounded-full object-cover h-full w-full shadow"
                    />
                  </div>
                  <div class="xl:pl-6 lg:pl-6 md:pl-6 sm:pl-6 sm:pt-0 pt-4">
                    <p class="text-xl text-black font-bold">Shade Bello</p>
                    <p class="sm:text-xl text-sm text-black">Software Engineer @Apple</p>
                  </div>
                </div>
                <svg width="85" height="65" xmlns="http://www.w3.org/2000/svg">
                  <text
                    transform="rotate(-180 475.5 56.5)"
                    fill="#EDF2F7"
                    fill-rule="evenodd"
                    font-family="ProximaNova-Extrabld, Proxima Nova"
                    font-size="200"
                    font-weight="600"
                    letter-spacing="1.667"
                  >
                    <tspan x="860" y="184">“</tspan>
                  </text>
                </svg>
              </div>
              <p class="text-base text-xl text-black pb-6 w-full sm:w-10/12">
                It really saves my  time and effort. Trackee is exactly what
                i was lacking as a Software Enginerr at Apple. Trackee was worth a fortune to my
                growth. I must recommend trackee as one of the best
                management tools
              </p>
              <img
                src="https://cdn.tuk.dev/assets/Path-right-arrow.png"
                alt=""
                class="absolute right-0 mr-16 sm:-mt-6 cursor-pointer"
                @click="moveForward()"
              />
            </div>
          </figure>
          <figure class="hidden">
            <div class="w-11/12 mx-auto bg-white py-10 sm:px-16 px-10 relative">
              <div class="flex items-center justify-between pb-8">
                <div class="xl:flex md:flex lg:flex sm:flex items-center">
                  <div class="h-20 w-20">
                    <img
                      src="/user/ben.png"
                      alt=""
                      class="rounded-full object-cover h-full w-full shadow"
                    />
                  </div>
                  <div class="xl:pl-6 lg:pl-6 md:pl-6 sm:pl-6 sm:pt-0 pt-4">
                    <p class="text-xl text-black font-bold">Winter Doe</p>
                    <p class="sm:text-xl text-sm text-black">Senior Product Designer @Amazon.</p>
                  </div>
                </div>
                <svg width="85" height="65" xmlns="http://www.w3.org/2000/svg">
                  <text
                    transform="rotate(-180 475.5 56.5)"
                    fill="#EDF2F7"
                    fill-rule="evenodd"
                    font-family="ProximaNova-Extrabld, Proxima Nova"
                    font-size="200"
                    font-weight="600"
                    letter-spacing="1.667"
                  >
                    <tspan x="860" y="184">“</tspan>
                  </text>
                </svg>
              </div>
              <p class="text-base text-xl text-black pb-6 w-full sm:w-10/12">
                Trackee has organized my work neatly and made it
                easier for me  to work quickly and on time. I love trackee
                so much 😊😊😊
              </p>

              <img
                src="https://cdn.tuk.dev/assets/Path-right-arrow.png"
                alt=""
                class="absolute right-0 mr-16 sm:-mt-6 cursor-pointer"
                @click="moveForward()"
              />
            </div>
          </figure>
          <figure class="hidden">
            <div class="w-11/12 mx-auto bg-white py-10 sm:px-16 px-10 relative">
              <div class="flex items-center justify-between pb-8">
                <div class="xl:flex md:flex lg:flex sm:flex items-center">
                  <div class="h-20 w-20">
                    <img
                      src="/user/edidiong.png"
                      alt=""
                      class="rounded-full object-cover h-full w-full shadow"
                    />
                  </div>
                  <div class="xl:pl-6 lg:pl-6 md:pl-6 sm:pl-6 sm:pt-0 pt-4">
                    <p class="text-xl text-black font-bold">Edidiong David</p>
                    <p class="sm:text-xl text-sm text-black">
                      Backend Developer @Avocodes
                    </p>
                  </div>
                </div>
                <svg width="85" height="65" xmlns="http://www.w3.org/2000/svg">
                  <text
                    transform="rotate(-180 475.5 56.5)"
                    fill="#EDF2F7"
                    fill-rule="evenodd"
                    font-family="ProximaNova-Extrabld, Proxima Nova"
                    font-size="200"
                    font-weight="600"
                    letter-spacing="1.667"
                  >
                    <tspan x="860" y="184">“</tspan>
                  </text>
                </svg>
              </div>
              <p class="text-base text-xl text-black pb-6 w-full sm:w-10/12">
                Trackee has helped me manage my team work much better. The
                intuitive interface makes implementation very easy.
              </p>

              <img
                src="https://cdn.tuk.dev/assets/Path-right-arrow.png"
                alt=""
                class="absolute right-0 mr-16 sm:-mt-6 cursor-pointer"
                @click="moveForward()"
              />
            </div>
          </figure>
          <!--slides for slider-->
        </section>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "FullWidthCardWithChevron",
  methods: {
    getFigures() {
      return document.getElementById("carousel").getElementsByTagName("figure");
    },
    moveForward() {
      var pointer = 0;
      var figures = this.getFigures();
      for (var i = 0; i < figures.length; i++) {
        if (figures[i].className == "visible") {
          figures[i].className = "hidden";
          pointer = i;
        }
      }
      if (++pointer == figures.length) {
        pointer = 0;
      }
      figures[pointer].className = "visible";
    },
  },
};
</script>

<style>
section#carousel > figure > div {
  display: none;
}
section#carousel > figure.visible > div {
  display: block;
  position: relative;
  overflow: hidden;
}
</style>
